import { Navigate } from 'react-router-dom'

import { useEffect } from 'modules/core/hooks/useEffect'

import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'
import useCustomPeriodPath from 'modules/attendance/lib/useCustomPeriodPath'

const NavigateToCustomPeriodIndexPage = () => {
  const { resetAttendanceDateNavigator } = useAttendanceDateNavigator()
  const path = useCustomPeriodPath()

  useEffect(() => {
    resetAttendanceDateNavigator()
  }, [])

  return <Navigate replace to={path} />
}

export default NavigateToCustomPeriodIndexPage
